import React from 'react';
import Select, { StylesConfig } from 'react-select';
import { ISelectOption } from '../ISelectOption';
import { IPointDeVente } from '../../../utils/types/IPointDeVente';

interface PdvSelectProps {
    pointsDeVente: IPointDeVente[];
    isPointsDeVenteLoading: boolean;
    setSelectedPdvId: (id: number | null) => void;
    selectedPdvId: number | null;
}

const customStyles: StylesConfig<ISelectOption, false> = {
    control: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
        maxWidth: '100%',
    }),
    singleValue: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menu: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
    }),
    option: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
};

const PdvSelect: React.FC<PdvSelectProps> = ({ pointsDeVente, isPointsDeVenteLoading, setSelectedPdvId, selectedPdvId }) => {
    const options: ISelectOption[] = pointsDeVente.map((pdv) => ({
        value: pdv.id.toString(),
        label: pdv.nom ?? '-',
    }));

    const selectedOption = options.find((option) => parseInt(option.value) === selectedPdvId) || null;

    const handleChange = (selectedOption: ISelectOption | null) => {
        setSelectedPdvId(selectedOption ? parseInt(selectedOption.value) : null);
    };

    return <Select id="autoSizingSelect" value={selectedOption} options={options} onChange={handleChange} placeholder={isPointsDeVenteLoading ? 'Chargement ...' : '--- Station'} isLoading={isPointsDeVenteLoading} isClearable isSearchable noOptionsMessage={() => 'Aucun point de vente'} styles={customStyles} classNamePrefix="react-select" menuPortalTarget={document.body} />;
};

export default PdvSelect;
